import { useState, useEffect } from "react";

const useClientAppFormRequest = (url) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [requestDetails, setRequestDetails] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      try {
        const resp = await fetch(url, { signal: controller.signal });
        const data = await resp.json();

        if (!!data.isValid) {
          setRequestDetails(data.config);
        } else if (data.error === "expired") {
          setError("This request has expired");
        } else if (data.error === "submitted") {
          setError("It looks like you've already submitted this data");
          setSubmitted(true);
        } else {
          setError("Failed to load request details");
        }
      } catch (err) {
        if (err.name === "AbortError") return;
        console.error("Failed to load request details", err);
        setError("Failed to load request details");
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => controller.abort();
  }, [url]);

  return { loading, error, requestDetails, submitted };
};

export default useClientAppFormRequest;
